<div class="special-marks-full">
  @if (isObjectEmpty(truthyAddons)) {
    -
  }
  @for (control of truthyAddons | keyvalue; track control; let index = $index) {
    @if (control.key === 'time_of_delivery' && control.value) {
      <span class="special-marks-full-text mb-0">
        {{ control.value }}
      </span>
    } @else {
      <p class="special-marks-full-text mb-0">
        {{ ADDONS_MAP.get(control.key) | translate }}
      </p>
    }
  }
</div>
